import { render } from "./shipment_code.vue?vue&type=template&id=30d5973f"
import script from "./shipment_code.vue?vue&type=script&lang=js"
export * from "./shipment_code.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__